module.exports = __webpack_public_path__ + "media/Video 6a.fb3bd23f.mp4";